import BaseStore from './base-store.js'
import StoreProxy from './store_proxy.js'
import {API_PROMPTS} from 'consts/api'


const PROMPTS_LIMIT = 50


export class Prompt extends BaseStore {
  constructor(values = {}) {
    super({
      id: undefined,
      title: undefined,
      prompt: undefined,
      last_used: undefined,
      ...values
    })
  }

  async update(id, data) {
    this.title = data?.title || this._state.title
    this.prompt = data?.prompt || this._state.prompt
    this.last_used = data?.last_used || this._state.last_used
    await this._rest.patch(`${API_PROMPTS}/${id}`, data)
  }
}

class Prompts extends BaseStore {
  constructor() {
    super({
      prompts: []
    })
  }
  async doLoad(){
    const res = await this._rest.get(API_PROMPTS)
    this._state.prompts = res.prompts.map(data => new Prompt(data))
    await this._enforcePromptLimit()
  }

  async savePrompt(title, prompt) {
    const saved_prompt = await this._rest.put(API_PROMPTS, {title, prompt})
    this._state.prompts.unshift(new Prompt(saved_prompt))
    await this._enforcePromptLimit()
  }

  async updatePrompt(id, data) {
    const prompt_item = this._state.prompts.find(prompt => prompt.id === id)
    await prompt_item.update(id, data)
  }

  async deletePrompt(id) {
    this._state.prompts = this._state.prompts.filter(prompt => prompt.id !== id)
    await this._rest.delete(`${API_PROMPTS}/${id}`)
  }
  
  async _enforcePromptLimit() {
    const sorted = this._state.prompts.toSorted((a, b) => new Date(b.last_used) - new Date(a.last_used))
    while (sorted.length > PROMPTS_LIMIT) {
      const to_remove = sorted.pop()
      await this.deletePrompt(to_remove.id)
    }
  }
}

const prompts = StoreProxy(new Prompts(), {array_prop: 'prompts'})
export default prompts
